/**
 * Loading state component with skeleton placeholders
 */
export function LoadingState() {
  // Show 12 skeleton cards while loading
  const skeletonCount = 12;

  return (
    <div className="video-grid">
      {Array.from({ length: skeletonCount }).map((_, index) => (
        <div key={index} className="video-card skeleton">
          <div className="skeleton-thumbnail" />
          <div className="skeleton-info">
            <div className="skeleton-title" />
            <div className="skeleton-channel" />
            <div className="skeleton-meta" />
          </div>
        </div>
      ))}
    </div>
  );
}

